import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import { genericRoute } from '../../../../routes';

//import InputText from '../../../form/input/text';
//import InputSubmit from '../../../form/input/submit';
//import lorem from '../../../../utils/lorem';

import ProfileSignedIn from './profileSignedIn';
import ProfileNotSignedIn from './profileNotSignedIn';

import css from './profile.scss';

export default class Profile extends Component {
	static PropTypes = {
		user: PropTypes.object,
		toggleMenu: PropTypes.func,
	};

	constructor(props) {
		super();

		this.state = {
			showLogin: false,
		};
	}

	render() {
		return (
			<div className='nav-profile'>
				{(!this.state.showLogin || this.props.user.isLoggedIn()) && (
				<div className='nav-profile__submit-case'>
					<Link to={genericRoute(false, 'submit/project')} className='button button--dark button--go' onClick={this.props.toggleMenu}>Submit your project</Link>
				</div>
				)}

				{this.props.user.isLoggedIn() ? (<ProfileSignedIn {...this.props} />) : (<ProfileNotSignedIn showLogin={this.state.showLogin} showLoginToggle={() => {this.setState({...this.state, showLogin: true,});}} {...this.props} />)}
			</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/globalNav/menu/profile/profile.js
 **/